// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2oyIu","header":"MergedInvoice_header__3Az1j"};